import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/resourceTimeOverview/styles.scss';export default {
  "resourceTimeOverview": "_resourceTimeOverview_14h0y_1",
  "cell": "_cell_14h0y_8",
  "text": "_text_14h0y_22"
};